import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'layout',
    component: () => import('../views/layout'),
    redirect: '/home',
    children: [
      { path: '/home', name: '首页', component: () => import('../views/home/index') },
      { path: '/school', name: '学校管理', component: () => import('../views/school/index') },
      { path: '/adminAccount', name: '管理员账号', component: () => import('../views/adminAccount/index') },
      { path: '/bigType', name: '商品大类', component: () => import('../views/bigType/index') },
      { path: '/smallType', name: '商品小类', component: () => import('../views/smallType/index') },
      { path: '/product', name: '商品管理', component: () => import('../views/product/index') },
      { path: '/user', name: '用户管理', component: () => import('../views/user/index') },
      { path: '/rider', name: '骑手管理', component: () => import('../views/rider/index') },
      { path: '/riderWithdraw', name: '骑手提现', component: () => import('../views/riderWithdraw/index') },
      { path: '/deliveryConfig', name: '配送与抽成', component: () => import('../views/deliveryConfig/index') },
      { path: '/order', name: '商城订单', component: () => import('../views/order/index') },
      { path: '/homeFeature', name: '首页入口', component: () => import('../views/homeFeature/index') },
      { path: '/serviceItem', name: '个性化服务', component: () => import('../views/serviceItem/index') },
      { path: '/courierPost', name: '代取快递广场', component: () => import('../views/courierPost/index') },
      { path: '/systemSetting', name: '系统配置', component: () => import('../views/systemSetting/index') },
      { path: '/subscribeMessageLog', name: '消息通知日志', component: () => import('../views/subscribeMessageLog/index') },
      { path: '/restaurantCategory', name: '餐厅分类', component: () => import('../views/restaurantCategory/index') },
      { path: '/restaurantDish', name: '餐厅菜品', component: () => import('../views/restaurantDish/index') },
      { path: '/restaurantOrder', name: '餐厅订单', component: () => import('../views/restaurantOrder/index') },
      { path: '/modifyPassword', name: '修改密码', component: () => import('../views/modifyPassword/index') }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
